// extracted by mini-css-extract-plugin
export default {"local-config":"p0h7qWCLkLPgXiUtXTTb","info-flex":"mxDzw_4f_rH1pF3bTux3"};